import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	// Actions
	actionEdit: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	actionUpdate: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	// Status lozenges
	incompatibleStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	nonAtlassianStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	systemStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	networkErrorStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	creationFailedStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	configurationIncompleteStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	inProgressStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	configurationComplete: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	submissionFailed: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	accessDeniedStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	configErrorStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	deprecatedStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	disabledStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	connectedStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	notConnectedStatus: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	// Auth token missing
	authTokenRequired: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	// Connection issues
	connectionRefusedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	connectionRefusedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	unknownHostTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	unknownHostDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	oauthProblemTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	oauthProblemDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	oauthTimestampRefusedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	oauthTimestampRefusedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	oauthSignatureInvalidTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	oauthSignatureInvalidDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	unexpectedResponseTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	unexpectedResponseDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	creationFailedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	creationFailedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	configurationIncompleteTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	configurationIncompleteDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	inProgressTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	inProgressDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	submissionFailedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	submissionFailedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	configurationCompleteTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	configurationCompleteDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchIncoming: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchOutgoing: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authTypeImpersonation: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authTypeDisabled: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authTypeUnknown: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchUnknownDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchDisabledOauthDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchOauthOauthDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchOauthDisabledDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelMismatchSuggestDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	unknownTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	unknownDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelUnsupportedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	authLevelUnsupportedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	sslUntrustedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	sslUntrustedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	sslHostnameUnmatchedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	sslHostnameUnmatchedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	sslUnmatchedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	sslUnmatchedDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	systemLinkTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	systemLinkDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	genericLinkTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	genericLinkDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	remoteVersionIncompatibleTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	remoteVersionIncompatibleDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	nonAtlassianTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	nonAtlassianDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	noRemoteApplinkTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	noRemoteApplinkDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	noOutgoingAuthTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	noOutgoingAuthDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	insufficientRemotePermissionTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	insufficientRemotePermission2LOi: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	insufficientRemotePermission2LOiExt: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	insufficientRemotePermission3Lo: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	insufficientRemotePermission3LoExt: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	legacyUpdateTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	legacyUpdateDescription1: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	legacyUpdateDescription2: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	legacyRemovalTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	legacyRemovalDescription1: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	legacyRemovalDescription2: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	manualLegacyUpdateTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	manualLegacyUpdateDescription1: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	manualLegacyUpdateDescription2: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	manualLegacyRemovalTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	manualLegacyRemovalDescription1: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	manualLegacyRemovalDescription2: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	manualLegacyRemovalDescription3: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	// Actions
	actionEdit: {
		defaultMessage: 'Edit application link',
		id: 'applinks.administration.ui.common.status.action-edit',
		description: 'Label for button to edit application link',
	},
	actionUpdate: {
		defaultMessage: 'Update application link',
		id: 'applinks.administration.ui.common.status.action-update',
		description: 'Label for button to update application link',
	},

	// Status lozenges
	incompatibleStatus: {
		defaultMessage: 'Status unavailable',
		id: 'applinks.administration.ui.common.status.incompatible-status',
		description: 'Status lozenge for incompatible application link',
	},
	nonAtlassianStatus: {
		defaultMessage: 'Non-Atlassian',
		id: 'applinks.administration.ui.common.status.non-atlassian-status',
		description: 'Status lozenge for non-Atlassian application link',
	},
	systemStatus: {
		defaultMessage: 'System',
		id: 'applinks.administration.ui.common.status.system-status',
		description: 'Status lozenge for system application link',
	},
	networkErrorStatus: {
		defaultMessage: 'Network error',
		id: 'applinks.administration.ui.common.status.network-error-status',
		description: 'Status lozenge for network error',
	},
	creationFailedStatus: {
		defaultMessage: 'Creation failed',
		id: 'applinks.administration.ui.common.status.creation-failed-status',
		description: 'Status lozenge for links needing recreation',
	},
	configurationIncompleteStatus: {
		defaultMessage: 'Configuration incomplete',
		id: 'applinks.administration.ui.common.status.configuration-incomplete-status',
		description: 'Status lozenge for links whose OAuth configuration is incomplete',
	},
	inProgressStatus: {
		defaultMessage: 'In progress',
		id: 'applinks.administration.ui.common.status.in-progress-status',
		description: 'Status lozenge for links being set up',
	},
	configurationComplete: {
		defaultMessage: 'Configuration complete',
		id: 'applinks.administration.ui.common.status.configuration-complete-status',
		description: 'Status lozenge for configuration complete links',
	},
	submissionFailed: {
		defaultMessage: 'Submission failed',
		id: 'applinks.administration.ui.common.status.submission-failed-status',
		description: 'Status lozenge for links whose submission failed',
	},
	accessDeniedStatus: {
		defaultMessage: 'Access denied',
		id: 'applinks.administration.ui.common.status.access-denied-status',
		description: 'Status lozenge for access denied',
	},
	configErrorStatus: {
		defaultMessage: 'Config error',
		id: 'applinks.administration.ui.common.status.config-error-status',
		description: 'Status lozenge for configuration error',
	},
	deprecatedStatus: {
		defaultMessage: 'Deprecated',
		id: 'applinks.administration.ui.common.status.deprecated-status',
		description: 'Status lozenge for deprecated links',
	},
	disabledStatus: {
		defaultMessage: 'Disabled',
		id: 'applinks.administration.ui.common.status.disabled-status',
		description: 'Status lozenge for disabled links',
	},
	connectedStatus: {
		defaultMessage: 'Connected',
		id: 'applinks.administration.ui.common.status.connected-status',
		description: 'Status lozenge for connected links',
	},
	notConnectedStatus: {
		defaultMessage: 'Not Connected',
		id: 'applinks.administration.ui.common.status.not-connected-status',
		description: 'Status lozenge for not connected links',
	},

	// Auth token missing
	authTokenRequired: {
		defaultMessage: 'Authenticate to see status',
		id: 'applinks.administration.ui.common.status.auth-token-required-title',
		description: 'Title for auth token required message',
	},

	// Connection issues
	connectionRefusedTitle: {
		defaultMessage: 'The remote application is not responding',
		id: 'applinks.administration.ui.common.status.connection-refused-title',
		description: 'Title for connection refused message',
	},
	connectionRefusedDescription: {
		defaultMessage:
			'The connection to <code>{rpcUrl}</code> was refused. <link>{applicationName}</link> may be down or blocked by a firewall. Alternatively, the Application URL for the remote application may be incorrect or may have changed recently.',
		id: 'applinks.administration.ui.common.status.connection-refused-description',
		description:
			'Description for connection refused message. Placeholders: rpcUrl = URL of application, applicationName = Name of application',
	},

	unknownHostTitle: {
		defaultMessage: 'Unable to reach the remote application',
		id: 'applinks.administration.ui.common.status.unknown-host-title',
		description: 'Title for unknown host message',
	},
	unknownHostDescription: {
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"We couldn't resolve the hostname at <code>{rpcUrl}</code>. There may be a DNS configuration problem, or the Application URL for the remote application may be incorrect or may have changed recently.",
		id: 'applinks.administration.ui.common.status.unknown-host-description',
		description: 'Description for unknown host message',
	},

	oauthProblemTitle: {
		defaultMessage: 'OAuth problem',
		id: 'applinks.administration.ui.common.status.oauth-problem-title',
		description: 'Title for OAuth problem message',
	},
	oauthProblemDescription: {
		defaultMessage:
			'There is an issue with the OAuth configuration of the connection to <link>{applicationName}</link>.',
		id: 'applinks.administration.ui.common.status.oauth-problem-description',
		description: 'Description for OAuth problem message',
	},

	oauthTimestampRefusedTitle: {
		defaultMessage: 'The system clocks are not synchronized',
		id: 'applinks.administration.ui.common.status.oauth-timestamp-refused-title',
		description: 'Title for OAuth timestamp refused message',
	},
	oauthTimestampRefusedDescription: {
		defaultMessage:
			'This server has a different system time from <link>{applicationName}</link>, which prevents the applications from authenticating.',
		id: 'applinks.administration.ui.common.status.oauth-timestamp-refused-description',
		description: 'Description for OAuth timestamp refused message',
	},

	oauthSignatureInvalidTitle: {
		defaultMessage: 'Invalid OAuth signature',
		id: 'applinks.administration.ui.common.status.oauth-signature-invalid-title',
		description: 'Title for invalid OAuth signature message',
	},
	oauthSignatureInvalidDescription: {
		defaultMessage:
			"We couldn't connect to <link>{applicationName}</link>, possibly because that instance is behind a mis-configured proxy.",
		id: 'applinks.administration.ui.common.status.oauth-signature-invalid-description',
		description: 'Description for invalid OAuth signature message',
	},

	unexpectedResponseTitle: {
		defaultMessage: 'Unexpected response',
		id: 'applinks.administration.ui.common.status.unexpected-response-title',
		description: 'Title for unexpected response message',
	},
	unexpectedResponseDescription: {
		defaultMessage:
			'We received an unexpected response from <link>{applicationName}</link>. If the remote application is behind a proxy, check that the application is operational. Troubleshoot this for other possible causes.',
		id: 'applinks.administration.ui.common.status.unexpected-response-description',
		description: 'Description for unexpected response message',
	},

	creationFailedTitle: {
		defaultMessage: 'Creation failed',
		id: 'applinks.administration.ui.common.status.creation-failed-status-title',
		description: 'Title for creation failed message',
	},
	creationFailedDescription: {
		defaultMessage:
			'This application link failed to create an OAuth 2.0 client. Delete it and create a new one.',
		id: 'applinks.administration.ui.common.status.creation-failed-status-description',
		description: 'Description for creation failed message',
	},

	configurationIncompleteTitle: {
		defaultMessage: 'Configuration incomplete',
		id: 'applinks.administration.ui.common.status.configuration-incomplete-status-title',
		description: 'Title for configuration incomplete message',
	},
	configurationIncompleteDescription: {
		defaultMessage:
			'This application link is missing a remote client ID and remote client secret. Add these details to complete configuration.',
		id: 'applinks.administration.ui.common.status.configuration-incomplete-status-description',
		description: 'Description for configuration incomplete message',
	},

	inProgressTitle: {
		defaultMessage: 'In progress',
		id: 'applinks.administration.ui.common.status.in-progress-status-title',
		description: 'Title for in progress message',
	},
	inProgressDescription: {
		defaultMessage: "We're still configuring the application link.",
		id: 'applinks.administration.ui.common.status.in-progress-status-description',
		description: 'Description for in progress message',
	},

	submissionFailedTitle: {
		defaultMessage: 'Submission failed',
		id: 'applinks.administration.ui.common.status.submission-failed-status-title',
		description: 'Title for submission failed message',
	},
	submissionFailedDescription: {
		defaultMessage: 'Resubmit this application link to complete configuration.',
		id: 'applinks.administration.ui.common.status.submission-failed-status-description',
		description: 'Description for submission failed message',
	},

	configurationCompleteTitle: {
		defaultMessage: 'Configuration complete',
		id: 'applinks.administration.ui.common.status.configuration-complete-status-title',
		description: 'Title for configuration complete message',
	},
	configurationCompleteDescription: {
		defaultMessage:
			'The configuration for your application link is complete. Try using it to confirm that everything works.',
		id: 'applinks.administration.ui.common.status.configuration-complete-status-description',
		description: 'Description for configuration complete message',
	},

	authLevelMismatchTitle: {
		defaultMessage: 'OAuth mismatch',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-title',
		description: 'Title for auth level mismatch message',
	},
	authLevelMismatchIncoming: {
		defaultMessage: 'incoming',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-incoming',
		description: 'Incoming connection text for auth level mismatch',
	},
	authLevelMismatchOutgoing: {
		defaultMessage: 'outgoing',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-outgoing',
		description: 'Outgoing connection text for auth level mismatch',
	},
	authTypeImpersonation: {
		defaultMessage: 'OAuth with impersonation',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-impersonation',
		description:
			'Shown for the auth type "OAuth with impersonation" - please translate impersonation but do not translate "OAuth"',
	},
	authTypeDisabled: {
		defaultMessage: 'Disabled',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-disabled',
		description: 'Shown when auth is disabled',
	},
	authTypeUnknown: {
		defaultMessage: 'Unknown',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-unknown',
		description: 'Shown when the auth type cannot be determined',
	},
	authLevelMismatchUnknownDescription: {
		defaultMessage:
			"We couldn't detect the authentication method for this application link. Make sure both the local and remote connections use the same authentication type.",
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-unknown-description',
		description: 'Description for unknown auth level mismatch',
	},
	authLevelMismatchDisabledOauthDescription: {
		defaultMessage:
			'The local {direction} connection is disabled, however <link>{applicationName}</link> uses {remoteAuthType}.',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-disabled-oauth-description',
		description:
			'Description for disabled-to-oauth auth level mismatch. {direction} is either "incoming" or "outgoing" (localised). {applicationName} is Jira, Confluence, etc. {remoteAuthType} is "OAuth", "Disabled", "OAuth with Impersonation".',
	},
	authLevelMismatchOauthOauthDescription: {
		defaultMessage:
			'The local {direction} connection uses {localAuthType}, however <link>{applicationName}</link> uses {remoteAuthType}.',
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-oauth-oauth-description',
		description:
			'Description for oauth-to-oauth auth level mismatch. {direction} is either "incoming" or "outgoing" (localised). {applicationName} is Jira, Confluence, etc. {localAuthType} is "OAuth", "Disabled", "OAuth with Impersonation". {remoteAuthType} is "OAuth", "Disabled", "OAuth with Impersonation".',
	},
	authLevelMismatchOauthDisabledDescription: {
		defaultMessage:
			"The local {direction} connection uses {localAuthType}, however it's disabled on <link>{applicationName}</link>.",
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-oauth-disabled-description',
		description:
			'Description for oauth-to-disabled auth level mismatch. {direction} is either "incoming" or "outgoing" (localised). {applicationName} is Jira, Confluence, etc. {localAuthType} is "OAuth", "Disabled", "OAuth with Impersonation".',
	},
	authLevelMismatchSuggestDescription: {
		defaultMessage:
			"You'll need to edit each connection to make sure the authentication methods are the same.",
		id: 'applinks.administration.ui.common.status.auth-level-mismatch-suggest-description',
		description: 'Suggestion description for auth level mismatch',
	},

	unknownTitle: {
		defaultMessage: 'Network error',
		id: 'applinks.administration.ui.common.status.unknown-title',
		description: 'Title for unknown error message',
	},
	unknownDescription: {
		defaultMessage:
			"We couldn't connect to {applicationName} at {rpcUrl}. This might have been caused by a network error or another configuration error.",
		id: 'applinks.administration.ui.common.status.unknown-description',
		description: 'Description for unknown error message',
	},

	authLevelUnsupportedTitle: {
		defaultMessage: 'Unsupported OAuth level',
		id: 'applinks.administration.ui.common.status.auth-level-unsupported-title',
		description: 'Title for unsupported OAuth level message',
	},
	authLevelUnsupportedDescription: {
		defaultMessage:
			'The current OAuth configuration prevents integrations from working. You need to update your configuration to OAuth or OAuth with impersonation.',
		id: 'applinks.administration.ui.common.status.auth-level-unsupported-description',
		description: 'Description for unsupported OAuth level message',
	},

	sslUntrustedTitle: {
		defaultMessage: "The remote certificate can't be trusted",
		id: 'applinks.administration.ui.common.status.ssl-untrusted-title',
		description: 'Title for untrusted SSL certificate message',
	},
	sslUntrustedDescription: {
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"<link>{applicationName}</link> may be using a self-signed SSL certificate or a certificate that was issued by a certificate authority that isn't known locally.",
		id: 'applinks.administration.ui.common.status.ssl-untrusted-description',
		description: 'Description for untrusted SSL certificate message',
	},

	sslHostnameUnmatchedTitle: {
		defaultMessage: "The remote certificate doesn't match the remote host name",
		id: 'applinks.administration.ui.common.status.ssl-hostname-unmatched-title',
		description: 'Title for SSL hostname mismatch message',
	},
	sslHostnameUnmatchedDescription: {
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"The SSL certificate used by <link>{applicationName}</link> can't be trusted because the certificate's host name doesn't match the URL {rpcUrl}.",
		id: 'applinks.administration.ui.common.status.ssl-hostname-unmatched-description',
		description: 'Description for SSL hostname mismatch message',
	},

	sslUnmatchedTitle: {
		defaultMessage: 'Unable to verify remote certificate details',
		id: 'applinks.administration.ui.common.status.ssl-unmatched-title',
		description: 'Title for unmatched SSL certificate message',
	},
	sslUnmatchedDescription: {
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"The SSL certificate used by <link>{applicationName}</link> can't be trusted because details inside the certificate can't be verified. Check that the remote certificate has the correct details.",
		id: 'applinks.administration.ui.common.status.ssl-unmatched-description',
		description: 'Description for unmatched SSL certificate message',
	},

	systemLinkTitle: {
		defaultMessage: 'Internal System Link',
		id: 'applinks.administration.ui.common.status.system-link-title',
		description: 'Title for system link message',
	},
	systemLinkDescription: {
		defaultMessage:
			'This is an internal link created automatically by the system. System internal links are read-only and cannot be edited.',
		id: 'applinks.administration.ui.common.status.system-link-description',
		description: 'Description for system link message',
	},

	genericLinkTitle: {
		defaultMessage: 'Link to external third party',
		id: 'applinks.administration.ui.common.status.generic-link-title',
		description: 'Title for generic link message',
	},
	genericLinkDescription: {
		defaultMessage:
			'This is an application link to an external third party. We are unable to retrieve the status to third parties. If you are experiencing any problems with your connection ensure that your OAuth configuration is correct.',
		id: 'applinks.administration.ui.common.status.generic-link-description',
		description: 'Description for generic link message',
	},

	remoteVersionIncompatibleTitle: {
		defaultMessage: 'Unable to retrieve status',
		id: 'applinks.administration.ui.common.status.remote-version-incompatible-title',
		description: 'Title for remote version incompatible message',
	},
	remoteVersionIncompatibleDescription: {
		defaultMessage:
			"We're unable to determine the status of this link, because the version of {applicationName} is a little too old. The link may actually be good. You can upgrade <link>{applicationName}</link> to the latest version of {applicationType} to get status and diagnostic capabilities.",
		id: 'applinks.administration.ui.common.status.remote-version-incompatible-description',
		description: 'Description for remote version incompatible message',
	},

	nonAtlassianTitle: {
		defaultMessage: 'Link to external third party',
		id: 'applinks.administration.ui.common.status.non-atlassian-title',
		description: 'Title for non-Atlassian link message',
	},
	nonAtlassianDescription: {
		defaultMessage:
			'This is an application link to an external third party. We are unable to retrieve the status to third parties, so if you are experiencing any problems with your connection reach out to the third party directly.',
		id: 'applinks.administration.ui.common.status.non-atlassian-description',
		description: 'Description for non-Atlassian link message',
	},

	noRemoteApplinkTitle: {
		defaultMessage: 'No remote application link',
		id: 'applinks.administration.ui.common.status.no-remote-applink-title',
		description: 'Title for no remote applink message',
	},
	noRemoteApplinkDescription: {
		defaultMessage:
			"We can't connect with <link>{applicationName}</link>  because a reciprocal application link is missing on that server. You'll need to delete and then re-create this application link.",
		id: 'applinks.administration.ui.common.status.no-remote-applink-description',
		description: 'Description for no remote applink message',
	},

	noOutgoingAuthTitle: {
		defaultMessage: 'No outgoing authentication',
		id: 'applinks.administration.ui.common.status.no-outgoing-auth-title',
		description: 'Title for no outgoing auth message',
	},
	noOutgoingAuthDescription: {
		defaultMessage:
			"We can't display the status for this application link, because outgoing authentication is disabled. You can enable outgoing authentication to see the status.",
		id: 'applinks.administration.ui.common.status.no-outgoing-auth-description',
		description: 'Description for no outgoing auth message',
	},

	insufficientRemotePermissionTitle: {
		defaultMessage: 'Access denied',
		id: 'applinks.administration.ui.common.status.insufficient-remote-permission-title',
		description: 'Title for insufficient remote permission message',
	},
	insufficientRemotePermission2LOi: {
		defaultMessage:
			"We couldn't retrieve the status from the remote application because your user account doesn't have admin privileges on {applicationName}.",
		id: 'applinks.administration.ui.common.status.insufficient-remote-permission-2loi',
		description: 'Description for insufficient remote permission (2LOi) message',
	},
	insufficientRemotePermission2LOiExt: {
		defaultMessage:
			'To see the status, ask for admin access for your account on <link>{applicationName}</link>.',
		id: 'applinks.administration.ui.common.status.insufficient-remote-permission-2loi-ext',
		description: 'Extended description for insufficient remote permission (2LOi) message',
	},
	insufficientRemotePermission3Lo: {
		defaultMessage:
			"We couldn't retrieve the status from the remote application because you don't have admin privileges on {applicationName}.",
		id: 'applinks.administration.ui.common.status.insufficient-remote-permission-3lo',
		description: 'Description for insufficient remote permission (3LO) message',
	},
	insufficientRemotePermission3LoExt: {
		defaultMessage:
			'To see the status, log out of <link>{applicationName}</link> and then <link2>authenticate</link2> as an admin on {applicationName}.',
		id: 'applinks.administration.ui.common.status.insufficient-remote-permission-3lo-ext',
		description: 'Extended description for insufficient remote permission (3LO) message',
	},

	legacyUpdateTitle: {
		defaultMessage: 'Deprecated authentication type',
		id: 'applinks.administration.ui.common.status.legacy-update-title',
		description: 'Title for legacy update message',
	},
	legacyUpdateDescription1: {
		defaultMessage:
			'This application link uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated.',
		id: 'applinks.administration.ui.common.status.legacy-update-description-1',
		description: 'First part of description for legacy update message',
	},
	legacyUpdateDescription2: {
		defaultMessage:
			'You should update this link to use OAuth authentication, the industry standard.',
		id: 'applinks.administration.ui.common.status.legacy-update-description-2',
		description: 'Second part of description for legacy update message',
	},

	legacyRemovalTitle: {
		defaultMessage: 'Deprecated authentication type',
		id: 'applinks.administration.ui.common.status.legacy-removal-title',
		description: 'Title for legacy removal message',
	},
	legacyRemovalDescription1: {
		defaultMessage:
			'As well as OAuth, this application link still uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated.',
		id: 'applinks.administration.ui.common.status.legacy-removal-description-1',
		description: 'First part of description for legacy removal message',
	},
	legacyRemovalDescription2: {
		defaultMessage:
			'You should update this link to use OAuth authentication, the industry standard.',
		id: 'applinks.administration.ui.common.status.legacy-removal-description-2',
		description: 'Second part of description for legacy removal message',
	},

	manualLegacyUpdateTitle: {
		defaultMessage: 'Deprecated authentication type',
		id: 'applinks.administration.ui.common.status.manual-legacy-update-title',
		description: 'Title for manual legacy update message',
	},
	manualLegacyUpdateDescription1: {
		defaultMessage:
			'This application link uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated.',
		id: 'applinks.administration.ui.common.status.manual-legacy-update-description-1',
		description: 'First part of description for manual legacy update message',
	},
	manualLegacyUpdateDescription2: {
		defaultMessage:
			'You should manually update this link to use OAuth authentication, the industry standard.',
		id: 'applinks.administration.ui.common.status.manual-legacy-update-description-2',
		description: 'Second part of description for manual legacy update message',
	},

	manualLegacyRemovalTitle: {
		defaultMessage: 'Deprecated authentication type',
		id: 'applinks.administration.ui.common.status.manual-legacy-removal-title',
		description: 'Title for manual legacy removal message',
	},
	manualLegacyRemovalDescription1: {
		defaultMessage: 'This application link uses a deprecated authentication type.',
		id: 'applinks.administration.ui.common.status.manual-legacy-removal-description-1',
		description: 'First part of description for manual legacy removal message',
	},
	manualLegacyRemovalDescription2: {
		defaultMessage:
			'You should click <bold>Update locally</bold> to move to OAuth authentication. Doing this will remove Trusted Applications authentication from this end of the link.',
		id: 'applinks.administration.ui.common.status.manual-legacy-removal-description-2',
		description: 'Second part of description for manual legacy removal message',
	},
	manualLegacyRemovalDescription3: {
		defaultMessage:
			"You'll then need to manually remove Trusted Applications authentication from the <link>{applicationName}</link> end of the link.",
		id: 'applinks.administration.ui.common.status.manual-legacy-removal-description-3',
		description: 'Third part of description for manual legacy removal message',
	},
});
export default messages;
